import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { CalendarScreen, type CalendarSearch } from "../components/calendar/CalendarScreen";

const searchSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  therapists: z.array(z.number().int()).optional(),
  rooms: z.array(z.string()).optional(),
  selected: z.string().uuid().optional(),
});

export const Route = createFileRoute("/_auth/calendar")({
  staticData: { titleKey: "nav.calendar", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 2 },
  validateSearch: searchSchema,
  component: CalendarRoute,
});

function CalendarRoute() {
  const search = Route.useSearch() as CalendarSearch;
  const navigate = useNavigate({ from: "/calendar" });
  return (
    <CalendarScreen
      search={search}
      onNavigate={(next) => {
        navigate({ search: (prev) => ({ ...prev, ...next }) as never });
      }}
    />
  );
}
